export const paths = {
  // common
  default: "/",
  any: "*",
  create: "create",
  view: "view",
  edit: "edit",
  approve: "approve",
  archived: "archived",
  management: "management",

  // campaigns
  campaigns: "campaigns",
  bonus_list: "bonus-list",
  campaign_list: "campaign-list",
  campaign_summary_view: "campaign-summary-view",
  campaign_calendar: "campaign-calendar",
  generic_setup: "generic-setup",
  segment_specific_setup: "segment-specific-setup",
  acitivity_level_setup: "activity-level-setup",
  acitivity_level_setup_new: "activity-level-setup-new",
  campaign_level_setup: "campaign-level-setup",
  rules_and_outcomes: "rules-and-outcomes",
  summary: "summary",

  // widgets
  widgets: "widgets",
  widget_list: "widget-list",
  create_member_history: "create-member-history",
  edit_member_history: "edit-member-history",
  create_member_information: "create-member-information",
  edit_member_information: "edit-member-information",
  create_list_of_campaigns: "create-list-of-campaigns",
  edit_list_of_campaigns: "edit-list-of-campaigns",
  create_list_of_sweepstakes: "create-list-of-sweepstakes",
  edit_list_of_sweepstakes: "edit-list-of-sweepstakes",

  //sweepstakes:
  sweepstakes: "sweepstakes",
  entrants_winners: "sweepstakes-management",
  pick_winners: "pick-winners",
  sweepstakes_archiving: "archiving",
  sweepstakes_list: "sweepstakes-list",
  sweepstakes_new: "sweepstakes-new",
  sweepstakes_details: "details",
  draw_details: "draw",

  // partner & partner code group
  partners: "partners",

  // winning rewards screen
  winning_rewards_screen: "winning-rewards-screen",

  //segmentation
  segmentation: "segmentation",
  segment_list: "segments-list",
  segment_summary_view: "segment-summary-view",
  platform_segments: "platform-segments",

  // content
  content: "content",
  content_pages: "content-pages",
  survey_list: "survey-list",
  // survey management
  survey_management: "survey-management",
  available_surveys: "available-surveys",
  banners: "banners",
  content_list: "content-list",
  details: "details",

  // rewards
  rewards: "rewards",
  rewards_redemption: "reward-orders",
  fulfillment_rules: "fulfillment-rules",
  rewards_catalogs: "rewards-catalogs",
  catalog_details: "catalog-details",
  products: "products",
  fulfillment_orders: "fulfillment-orders",
  customized_rewards: "customized-rewards",
  //code groups
  code_groups: "code-groups",
  // member relations
  member_list: "member-list",
  member: "member",

  // performances
  performances_list: "performances-list",
  performance_details: "performance-details",
  package_scans_performances: "package-scans-performances",
  receipt_scan_performances: "receipt-scan-performances",
  qr_scan_performances: "qr-scan-performances",
  code_scan_performances: "code-scan-performances",

  //management
  app_configurations: "app-configurations",
  system_setting: "system-setting",
  system_setting_widgets_view: "widgets-view",
  term_and_condition: "term-and-condition",
  term_and_condition_view: "term-and-condition-view",
  term_and_condition_edit: "term-and-condition-edit",
  user_login_limits: "user-login-limits",
  history_logs_view: "history-logs-view",
  history_logs: "history-logs",
  keywords_management: "keywords-management",
  store_management: "store-management",
  store_create: "create",
  store_edit: "edit",

  // product management
  product_management: "product-management",
  product_create: "create",
  product_edit: "edit",

  social_media_links: "social-media-links",
  widgets_configuration: "widgets-configuration",
  partner_configuration: "partner-configuration",
  generic_configuration: "generic-configuration",
  global_outcomes: "global-outcomes",
  market_specific: "market_specific",

  // test route
  all_components: "all-components",

  //customer suppport
  call_center: "customer-support",
  member_lookup: "member-lookup",
  code_search: "code-search",

  customized_reward_details: "customized-reward-details",

  // leaderboard
  leaderboards: "leaderboards",
  // winning schedules
  winning_schedules: "winning-schedules",
};
